export enum ProductState {
  Active = 1,
  Inactive = 2,
}

export enum ProductVisibility {
  Visible = 1,
  Invisible = 2,
}
